function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EEEDEC"
    },
    d: "M10,0h16c5.52,0,10,4.48,10,10v16 c0,5.52-4.48,10-10,10H10C4.48,36,0,31.52,0,26V10C0,4.48,4.48,0,10,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A8A6A1"
    },
    d: "M27.97,12.71c0-2.08-0.28-2.71-3.99-2.71V8h-2v2h-7.99V8h-2v2 h-2c-1.1,0-2,0.9-2,2l0.06,13.76c0,1.1,0.96,2.24,2.06,2.24H26.1c1.1,0,1.9-1.02,1.9-2.24C28,25.37,27.97,13.36,27.97,12.71z  M25.97,25c0,0.55-0.45,1-1,1H11c-0.55,0-1-0.45-1-1v-7h15.97C25.97,18,25.97,25,25.97,25z M25.97,16H10v-3.03 c0-0.54,0.43-0.97,0.97-0.97H12v2h2v-2h7.99v2h2v-2h1c0.55,0,1,0.45,1,1v3H25.97z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateGrey);
export default __webpack_public_path__ + "static/media/date_grey.97a47940.svg";
export { ForwardRef as ReactComponent };